<template>
  <div>
    <v-row no-gutters>
      <span class="body-2 font-weight-medium">Your Mapping Licences: APGB</span>
    </v-row>

    <v-row>
      <v-col>
        <v-row no-gutters class="mt-2">
          <span class="body-2">Aerial Photography Great Britain (APGB) is the
            <span class="body-2 font-weight-medium">free agreement that licences your Council to use the latest aerial photography</span>
            and height data from the GB Consortium (Bluesky and Getmapping).
          </span>
        </v-row>
        <div v-if="PSMA.length === 0">
          <v-row no-gutters class="mt-2">
            <span class="body-2 font-weight-bold">As no PSGA number was provided we can't register you for this licence at this time.</span>
          </v-row>
        </div>
        <div v-else>
          <v-row no-gutters class="ml-4">
            <v-radio-group column v-model="hasAPGB">
              <v-radio label="We are already signed up"
                       value="yes"
                       color="info">
              </v-radio>
              <v-radio label="We haven't signed up yet"
                       value="no"
                       color="info">
              </v-radio>
            </v-radio-group>
          </v-row>
          <v-row no-gutters v-if="hasAPGB === 'yes'">
            <v-col>
              <v-divider></v-divider>
              <v-checkbox v-model="confirmAPGB"
                          class="ml-4"
                          color="info"
                          label="I confirm we are already an APGB member"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row no-gutters v-else-if="hasAPGB === 'no'">
            <v-col>
              <v-divider class="mr-4"></v-divider>
              <v-row no-gutters class="mt-6">
                <span class="body-2">Don't worry, we can register your APGB membership from here.</span>
              </v-row>
              <v-row no-gutters class="mt-2">
          <span class="body-2">To do this we'll need to pass your details on to the GB Consortium and you'll need to agree to the
            <a class="bpdy-2 font-weight-medium" target="_blank"
               href="https://www.parish-online.co.uk/forms/apgb/apgb_member_licence.pdf">
              Member Licence.
            </a>
          </span>
              </v-row>
              <v-row no-gutters class="ml-4 mt-2">
                <v-col>
                  <span class="body-2">Would you like to sign up now?</span>
                  <v-radio-group row v-model="wantsAPGB">
                    <v-radio label="Yes, please sign me up"
                             value="yes"
                             color="info">
                    </v-radio>
                    <v-radio label="No, thank you"
                             value="no"
                             color="info">
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col>
        <img src="@/assets/withwithout_apgb.jpg">
      </v-col>
    </v-row>


    <v-row no-gutters class="mt-2" style="height: 24px" align="center">
      <span v-if="isAllValid" class="body-2">Click "Next" to continue the signup process.</span>
      <div v-else>
        <span v-if="hasAPGB === 'yes' && confirmAPGB === false" class="body-2 font-weight-medium" style="color: #BF1722">Please confirm.</span>
        <span v-if="hasAPGB === 'no' && wantsAPGB === ''" class="body-2 font-weight-medium" style="color: #BF1722">Please select an option.</span>
      </div>
    </v-row>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "StepSeven",
    components: {},
    props: {
      valid: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        hasAPGB: '',
        wantsAPGB: '',
        confirmAPGB: false,
      }
    },
    computed: {
      ...mapGetters({
        PSMA: 'GET_PSMA_NUMBER',
      }),
      isAllValid() {
        let valid = this.hasAPGB === 'yes' ? this.confirmAPGB : this.wantsAPGB !== '';
        if (this.hasAPGB === 'yes') {
          this.$store.commit('SET_HAS_APGB', true);
          this.$store.commit('SET_WANTS_APGB', false);
        } else if (this.hasAPGB === 'no') {
          if (this.wantsAPGB === 'yes') {
            this.$store.commit('SET_HAS_APGB', false);
            this.$store.commit('SET_WANTS_APGB', true);
          } else {
            this.$store.commit('SET_HAS_APGB', false);
            this.$store.commit('SET_WANTS_APGB', false);
          }
        }
        if (this.PSMA === '') {
          this.$store.commit('SET_HAS_APGB', false);
          this.$store.commit('SET_WANTS_APGB', false);
          valid = true;
        }
        this.$emit('update:valid', valid);
        return valid;
      }
    },
    methods: {}
  }
</script>
